import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {Router} from '@angular/router';
import {Registration} from 'src/app/pages/sign-up/sign-up.page';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {environment} from 'src/environments/environment';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {numberToCurrency} from 'src/smoothr-web-app-core/utils/utils';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';

@Component({
	selector: 'app-order-page-toolbar',
	templateUrl: './order-page-toolbar.component.html',
	styleUrls: ['order-page-toolbar.component.scss']
})
export class OrderPageToolbarComponent implements OnInit {
	@Output()
	backClick = new EventEmitter<void>();
	@Output()
	close = new EventEmitter<void>();
	@Input()
	preorderType: PreorderType;
	@Input()
	title: string;
	@Input()
	hideElements: boolean;
	@Input()
	showOnlyCross: boolean = false;
	environment = environment;
	customer = this.repository.customer;
	constructor(
		private repository: RepositoryService,
		private navService: NavigationService,
		private router: Router
	) {}

	ngOnInit() {}

	onBackClick() {
		this.backClick.emit();
	}
	onClose() {
		this.close.emit();
	}
	backClickFunc() {
		this.navService.order();
	}
	signIn() {
		this.navService.navigateToUrlWithParamsWithourReplace(NAVIGATIONURLS.signUp(), {auth: Registration.SIGN_IN});
	}

	showPrice() {
		if (this.repository._order) {
			return numberToCurrency(
				OrderUtils.orderTotalPrice(
					this.repository._order,
					true,
					true,
					(this.repository._order?.subscriptions ?? []).concat(
						this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription)
					)
				),
				this.repository._order?.currency
			);
		} else {
			return '';
		}
	}
}
